import * as React from 'react';
import { EllipsisIcon } from 'lucide-react';
import { eventBus } from 'services/eventBus';
import { usePermission } from 'hooks/usePermission'
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

type Props = {
  event: RestrictionEvent
}

export const EventActionsMenu = ({ event }: Props) => {
  const { hasPermissionTo } = usePermission()

  const justified = !!event.justification;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger onClick={(event) => {
        event.stopPropagation();
      }}>
        <EllipsisIcon className={'text-gray-600'} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={'end'}>
        <DropdownMenuItem disabled={!justified} onClick={(e) => {
          eventBus.dispatch('open-show-event-justification-drawer', event);
          e.stopPropagation();
        }}>
          Ver justificativa
        </DropdownMenuItem>
        {hasPermissionTo(['RES.RESTRICTEDMATERIALS.ADDJUSTIFICATIONTOEVENT']) && (
          <DropdownMenuItem disabled={justified} onClick={(e) => {
            eventBus.dispatch('open-justify-event-drawer', event);
            e.stopPropagation();
          }}>
            Adicionar justificativa
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};